"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleCollapsePA = exports.removePAIdsFromList = exports.mapProductAreaIdsToString = exports.getSelectedProductAreas = exports.getNormalizedPAList = exports.getFilteredProductAreas = exports.getChildPAIds = exports.flattenPAList = exports.findProductAreaById = exports.filterProductAreasByTitle = exports.filterProductAreasById = exports.addPAIdsToList = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _interfaces = require("@insided/shared/interfaces");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var flattenPAList = function flattenPAList(productAreas) {
  var flatPAList = [];
  productAreas.forEach(function (productAreas) {
    flatPAList.push({
      id: String(productAreas.id),
      name: productAreas.name,
      isSection: productAreas.isSection
    });

    if (productAreas.children.length > 0) {
      flatPAList.push.apply(flatPAList, (0, _toConsumableArray2.default)(flattenPAList(productAreas.children)));
    }
  });
  return flatPAList;
};

exports.flattenPAList = flattenPAList;

var getNormalizedPAList = function getNormalizedPAList(productAreas) {
  var normalizedPAList = [];
  productAreas === null || productAreas === void 0 ? void 0 : productAreas.forEach(function (productArea) {
    normalizedPAList.push({
      id: String(productArea.id),
      name: productArea.name,
      isSection: productArea.isSection,
      value: productArea.id.toString(),
      children: getNormalizedPAList(productArea.children),
      title: productArea.name
    });
  });
  return normalizedPAList;
};

exports.getNormalizedPAList = getNormalizedPAList;

var getChildPAIds = function getChildPAIds(productAreas) {
  return productAreas.filter(function (_ref) {
    var isSection = _ref.isSection;
    return !isSection;
  }).map(function (_ref2) {
    var id = _ref2.id;
    return String(id);
  });
};

exports.getChildPAIds = getChildPAIds;

var addPAIdsToList = function addPAIdsToList(productAreaIdList, productArea, childrenIds) {
  if (productArea.isSection) {
    productAreaIdList.push.apply(productAreaIdList, (0, _toConsumableArray2.default)(childrenIds));
  } else {
    productAreaIdList.push(String(productArea.id));
  }

  return productAreaIdList;
};

exports.addPAIdsToList = addPAIdsToList;

var removePAIdsFromList = function removePAIdsFromList(productAreaIdList, productArea, childrenIds) {
  if (productArea.isSection) {
    return productAreaIdList.filter(function (id) {
      return !childrenIds.includes(id);
    });
  }

  return productAreaIdList.filter(function (id) {
    return id !== String(productArea.id);
  });
};

exports.removePAIdsFromList = removePAIdsFromList;

var filterProductAreasByTitle = function filterProductAreasByTitle(productAreas, title) {
  return productAreas.reduce(function (acc, productArea) {
    if (productArea.title.toLowerCase().includes(title.toLowerCase())) {
      acc.push(productArea);
    } else if (productArea.children.length > 0) {
      var filteredChildren = filterProductAreasByTitle(productArea.children, title);

      if (filteredChildren.length > 0) {
        acc.push(_objectSpread(_objectSpread({}, productArea), {}, {
          children: filteredChildren
        }));
      }
    }

    return acc;
  }, []);
};

exports.filterProductAreasByTitle = filterProductAreasByTitle;

var findProductAreaById = function findProductAreaById(productAreas, id) {
  var _iterator = _createForOfIteratorHelper(productAreas),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var productArea = _step.value;
      if (Number(productArea.id) === Number(id)) return productArea;

      if (productArea.children.length > 0) {
        var found = findProductAreaById(productArea.children, id);
        if (found) return found;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return undefined;
};

exports.findProductAreaById = findProductAreaById;

var getSelectedProductAreas = function getSelectedProductAreas(selectedPAIdsCopy, productAreas) {
  return selectedPAIdsCopy.reduce(function (acc, id) {
    var productArea = findProductAreaById(productAreas, id);
    if (productArea) acc.push(productArea);
    return acc;
  }, []);
};

exports.getSelectedProductAreas = getSelectedProductAreas;

var getFilteredProductAreas = function getFilteredProductAreas(value, productAreas) {
  if (!value) return productAreas;
  var filteredProductAreas = filterProductAreasByTitle(productAreas, value);
  return filteredProductAreas.length ? filteredProductAreas : [];
};

exports.getFilteredProductAreas = getFilteredProductAreas;

var toggleCollapsePA = function toggleCollapsePA(productAreas, id) {
  return productAreas.map(function (oldPA) {
    var productArea = _objectSpread({}, oldPA);

    if (productArea.id === id) {
      productArea.isCollapsed = !productArea.isCollapsed;
    }

    if (productArea.children.length > 0) {
      return _objectSpread(_objectSpread({}, productArea), {}, {
        children: toggleCollapsePA(productArea.children, id)
      });
    }

    return productArea;
  });
};

exports.toggleCollapsePA = toggleCollapsePA;

var mapProductAreaIdsToString = function mapProductAreaIdsToString(productAreas) {
  return productAreas.reduce(function (acc, productArea) {
    acc.push(String(productArea.id));

    if (productArea.children.length > 0) {
      acc.push.apply(acc, (0, _toConsumableArray2.default)(mapProductAreaIdsToString(productArea.children)));
    }

    return acc;
  }, []);
};

exports.mapProductAreaIdsToString = mapProductAreaIdsToString;

var filterProductAreasById = function filterProductAreasById() {
  var productAreas = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var productAreaFilterList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var selectedProductAreaFilterOption = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _interfaces.ProductAreaFilterOptionMap.SectionsAndProductAreas;

  if (selectedProductAreaFilterOption === _interfaces.ProductAreaFilterOptionMap.SectionsOnly) {
    return productAreas.reduce(function (acc, productArea) {
      if (productArea.isSection) {
        acc.push(_objectSpread(_objectSpread({}, productArea), {}, {
          children: []
        }));
      }

      return acc;
    }, []);
  }

  if (selectedProductAreaFilterOption === _interfaces.ProductAreaFilterOptionMap.SpecificProductAreas) {
    return productAreas.reduce(function (acc, productArea) {
      if (productAreaFilterList.includes(Number(productArea.id))) {
        acc.push(_objectSpread(_objectSpread({}, productArea), {}, {
          children: []
        }));
      } else if (productArea.children.length > 0) {
        var filteredChildren = filterProductAreasById(productArea.children, productAreaFilterList, selectedProductAreaFilterOption);

        if (filteredChildren.length > 0) {
          acc.push(_objectSpread(_objectSpread({}, productArea), {}, {
            children: filteredChildren
          }));
        }
      }

      return acc;
    }, []);
  }

  return productAreas;
};

exports.filterProductAreasById = filterProductAreasById;